import { userReviews } from '@/mocks/clsqData';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-sm ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
        ></i>
      ))}
    </div>
  );
}

export default function UserReviewsSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-secondary-100/80 text-secondary-700 rounded-full text-xs font-medium mb-4">
            用户评价
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            客户见证
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            聆听来自各行业客户的声音，了解clsq如何为他们创造价值
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {userReviews.map((review) => (
            <div
              key={review.id}
              className="p-6 md:p-8 bg-background-100 rounded-lg border border-background-200/60"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">{review.name}</h4>
                  <p className="text-xs text-foreground-500">{review.title}</p>
                </div>
              </div>
              <StarRating rating={review.rating} />
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{review.content}</p>
              <div className="mt-4 text-accent-500">
                <i className="ri-double-quotes-r text-2xl opacity-30"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}